import React from "react";
import ArrowSvg from "../../../../../prod/images/_arrow.svg?react";
import "./Header.scss";
import { CatalogueHeaderItemsData } from "../../../../api/headerApi.types";
import { CatalogueMegaMenuSubItem } from "./CatalogueMegaMenuSubItem";

interface CatalogueMegaMenuItemProps {
  item: CatalogueHeaderItemsData;
}

export const CatalogueMegaMenuItem: React.FC<CatalogueMegaMenuItemProps> = ({
  item,
}) => {
  return (
    <div className="header-bot-expanded-menu">
      <h2 className="header-bot-expanded-menu-title">
        {item?.linkTitle && <a href={item.linkUrl}>{item.linkTitle}</a>}
      </h2>
      {item?.subItems?.length > 0 && (
        <ul className="header-bot-expanded-menu-item">
          {item?.subItems?.map((subItem) => (
            <CatalogueMegaMenuSubItem item={subItem} />
          ))}
        </ul>
      )}
    </div>
  );
};
